import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'

import { Tabs, Tab, Container } from '@mch-group/uikit-components'
import cssClasses from '@constants/cssClasses'

import { useActiveTab } from '@hooks'
import { useModuleContext } from '@modules/GalleryProfile/Context'
import useRequestLabels from '@hooks/useRequestLabels'

import Title from './Shared/Title'
import OverviewTab from './OverviewTab'
import LocationsTab from './LocationsTab'
import EventsAndExhibitionsTab from './EventsAndExhibitionsTab'
import CatalogTab from './CatalogTab'
import { PageContext } from '@providers/PageContext'

const GalleryProfile: FC<IGallProfile> = () => {
  const router = useRouter()
  const activeTab = useActiveTab('overview')
  const {
    page: { pageData: pageMetaInfo }
  } = useContext(PageContext)
  useRequestLabels(['CollectionForms', 'OnlineShowRoom'], useModuleContext)
  const {
    state: { CMSProps }
  } = useModuleContext()

  const onChangeTab = (value) => {
    router.push(
      {
        pathname: '/',
        query: {
          activeTab: value
        }
      },
      `${window.location.pathname}?activeTab=${value}`,
      { shallow: true }
    )
  }

  React.useEffect(() => {
    const divs = document.querySelectorAll('.preview-module')
    Array.prototype.forEach.call(divs, (o) => {
      const div = o
      div.style.display = activeTab !== 'overview' ? 'none' : 'block'
    })
  }, [activeTab])
  return (
    <StyledGalleryProfile className='mt-0'>
      <Title pageMetaInfo={pageMetaInfo} lastExhibitionLabel={CMSProps.gpv_grp1_label_gallery_last_exhibited} />
      <Container className={`px-5 mx-md-auto px-lg-8 px-md-7 ${cssClasses.CMS_MODULE}`}>
        <Tabs className='mb-3' activeKey={activeTab} onSelect={(k) => onChangeTab(k)}>
          {CMSProps.gpv_grp1_label_overview && (
            <Tab eventKey='overview' title={CMSProps.gpv_grp1_label_overview}>
              <OverviewTab pageMetaInfo={pageMetaInfo} readMoreLabel={CMSProps.gpv_grp1_label_read_more} />
            </Tab>
          )}
          {CMSProps.gpv_grp1_label_events && (
            <Tab eventKey='events' title={CMSProps.gpv_grp1_label_events}>
              {activeTab === 'events' && <EventsAndExhibitionsTab pageMetaInfo={pageMetaInfo} />}
            </Tab>
          )}
          {CMSProps.gpv_grp1_label_locations && (
            <Tab eventKey='locations' title={CMSProps.gpv_grp1_label_locations}>
              {activeTab === 'locations' && (
                <LocationsTab
                  className='gallery-locations'
                  addresses={pageMetaInfo?.addresses}
                  locationsLabel={CMSProps.gpv_grp1_label_locations}
                />
              )}
            </Tab>
          )}
          {CMSProps.gpv_grp1_label_shows_catalog && (
            <Tab eventKey='catalog' title={CMSProps.gpv_grp1_label_shows_catalog}>
              {activeTab === 'catalog' && <CatalogTab />}
            </Tab>
          )}
        </Tabs>
      </Container>
    </StyledGalleryProfile>
  )
}

interface IGallProfile {
  className: string
  pageMetaInfo: any
  gpv_grp1_label_overview: string
  gpv_grp1_label_events: string
  gpv_grp1_label_shows_catalog: string
  gpv_grp1_label_read_more: string
  gpv_grp1_label_gallery_last_exhibited: string
  gpv_grp1_label_all_artworks: string
  gpv_grp1_label_all_artists: string
  gpv_grp1_label_locations: string
  gpv_grp1_random_sort_label: string
  gpv_grp1_artist_sort_label: string
  gpv_grp1_show_sort_label: string
  gpv_grp1_title_sort_label: string
  gpv_grp1_year_asc_sort_label: string
  gpv_grp1_year_desc_sort_label: string
}

const StyledGalleryProfile = styled.div<any>`
  .scroll {
    &-left {
      padding-left: 0 !important;
    }

    &-right {
      padding-right: 0 !important;
    }
  }

  .expand-btn {
    display: block;
    margin-bottom: 42px;

    @media (min-width: ${global.uikitVars.breakpointMd}) {
      margin-bottom: 30px;
    }
  }

  .actions-bar {
    justify-content: flex-start;
  }

  .overview-text {
    @media (max-width: ${global.uikitVars.breakpointSmMax}) {
      & > div:first-child {
        order: 2;
      }

      & > div:last-child {
        order: 1;
      }
    }
  }

  .gallery-detail-overview {
    margin-top: 33px !important;

    @media (min-width: ${global.uikitVars.breakpointMd}) {
      margin-top: 48px !important;
    }
  }

  .gallery-locations {
    margin-top: 33px !important;

    @media (min-width: ${global.uikitVars.breakpointMd}) {
      margin-top: 48px !important;
    }
  }

  .gallery-events-browse.cms-module {
    margin-top: 41px !important;
    padding-top: 0;

    @media (min-width: ${global.uikitVars.breakpointMd}) {
      margin-top: 41px !important;
      margin-bottom: -32px !important;
    }
  }

  .gallery-artworks.cms-module {
    margin-top: 40px !important;
    padding-top: 0;

    @media (min-width: ${global.uikitVars.breakpointMd}) {
      margin-top: 42px !important;
    }
  }

  .otm-browse-events {
    padding-left: 0;
    padding-right: 0;
  }
`

export default GalleryProfile
